import { LinearGradient } from 'expo-linear-gradient';

const Animated = {};

export { Animated, LinearGradient };
